import { handleActions } from 'redux-actions';
import * as profileCardActions from '../actions/profileCard';

let initState = {
  data: {},
  isLoading: false,
  checkUserByPhoneNumber: null,
};

export const profileCard = handleActions(
  {
    [profileCardActions.getEmployee]: (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    },
    [profileCardActions.getEmployeeSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          ['id' + payload.id]: payload.data,
        },
      };
    },
    [profileCardActions.getEmployeeError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        isLoading: false,
        err: true,
        errData: payload,
      };
    },
    [profileCardActions.updateEmployee]: (state, action) => {
      return {
        ...state,
        updateIsLoading: true,
      };
    },
    [profileCardActions.updateEmployeeSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        updateIsLoading: false,
        updateProfile: payload.id,
        data: {
          ...state.data,
          ['id' + payload.id]: payload.data,
        },
        updateSuccess: state.updateSuccess ? state.updateSuccess + 1 : 1,
      };
    },
    [profileCardActions.updateEmployeeError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        updateIsLoading: false,
        updateProfile: false,
        createErr: true, // todo привести в единый стиль с update + create
        createErrData: payload,
      };
    },
    [profileCardActions.createEmployee]: (state, action) => {
      return {
        ...state,
        createIsLoading: true,
      };
    },
    [profileCardActions.createEmployeeSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        createIsLoading: false,
        createProfile: payload.id,
        data: {
          ...state.data,
          ['id' + payload.id]: payload.data,
        },
      };
    },
    [profileCardActions.createEmployeeError]: (state, action) => {
      let { payload } = action;
      if (state.createErrData === payload) {
        console.log('!!!!! СОВПАДАЮТ');
      }
      return {
        ...state,
        createIsLoading: false,
        createProfile: false,
        createErr: true,
        createErrData: payload,
      };
    },
    [profileCardActions.createEmployeeClearError]: state => {
      return {
        ...state,
        createErr: false,
        createErrData: null,
      };
    },
    [profileCardActions.updateEmployeeStatusSuccess]: (state, action) => {
      let { payload } = action;
      if (state.data && state.data['id' + payload.id]) {
        return {
          ...state,
          data: {
            ...state.data,
            ['id' + payload.id]: {
              ...state.data['id' + payload.id],
              ...payload.data,
            },
          },
        };
      } else {
        return state;
      }
    },
    [profileCardActions.updateEmployeeStatusError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        updateIsLoading: false,
        updateProfile: false,
        createErr: true,
        createErrData: payload,
      };
    },

    [profileCardActions.getCheckUserByPhoneNumber]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        checkUserByPhoneNumber: { phone: payload, status: 'isLoading' },
      };
    },
    [profileCardActions.getCheckUserByPhoneNumberSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        checkUserByPhoneNumber: { ...payload },
      };
    },
    [profileCardActions.getCheckUserByPhoneNumberError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        checkUserByPhoneNumber: {
          phone: payload.phone,
          status: 'error',
          err: payload.err,
        },
      };
    },
  },
  initState
);
